import React from "react";

const YoutubeIcon = props => (
  <svg width={512} height={512} viewBox="0 0 97.75 97.75" {...props}>
    <g fill="#FFF">
      <path d="M39.969 59.587L61.91 48.211c-7.359-3.84-14.627-7.63-21.941-11.447v22.823z" />
      <path d="M48.875 0C21.883 0 0 21.882 0 48.875S21.883 97.75 48.875 97.75 97.75 75.868 97.75 48.875 75.867 0 48.875 0zm33.301 65.189c-.846 3.67-3.848 6.377-7.461 6.78-8.557.957-17.217.962-25.842.957-8.625.005-17.287 0-25.846-.957-3.613-.403-6.613-3.11-7.457-6.78-1.203-5.228-1.203-10.933-1.203-16.314s.014-11.088 1.217-16.314c.844-3.67 3.844-6.378 7.457-6.782 8.559-.956 17.221-.961 25.846-.956 8.623-.005 17.285 0 25.841.956 3.615.404 6.617 3.111 7.461 6.782 1.203 5.227 1.193 10.933 1.193 16.314s-.003 11.087-1.206 16.314z" />
    </g>
  </svg>
);

export default YoutubeIcon;
